<div class="bcg p-4">
    <div class="row">
        <div class="col-8">
            <div class="d-flex justify-content-between custom-container">
                <nav class="custom-nav">
                    <ol class="breadcrumb">
                        <li *ngIf="userRole === 'CLIENT'; else showAdminDashboard" class="breadcrumb-item"
                            style="cursor: pointer;" [routerLink]="'/doqfy/dashboard'">Dashboard</li>
                        <ng-template #showAdminDashboard>
                            <li class="breadcrumb-item" style="cursor: pointer;"
                                [routerLink]="'/doqfy/admin-dashboard'">Dashboard</li>
                        </ng-template>
                        <li class="breadcrumb-item active" style="cursor: context-menu;" aria-current="page">Contract
                            Execution Order</li>
                    </ol>
                </nav>
            </div>
        </div>
        <div *ngIf="showUploadDocuments" class="col-lg-4 col-sm-6 col-md-6">
            <app-select-branch (OnBranchChangeData)=changeState($event)></app-select-branch>
        </div>
    </div>

    <div *ngIf="showUploadDocuments" class="card mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <h5 class="card-title title_header_0">Contract Execution - CAT-Upload</h5>
                    <p class="card-text text_p ">Ensure your documents are signed and stamped with ease by following a
                        few simple steps.</p>
                </div>
                <div class="col-lg-6 col-sm-6 col-md-6 text-right custom_button">

                    <p-button label="Back" (click)="back()" styleClass="p-button-sm"></p-button>
                </div>
            </div>
        </div>
    </div>
    <div class="card m-4 card_style_bs_order_cat">
        <div class="card-body">
            <h5 class="card-title title_header_0">Complete Your Process in Just 4 Easy Steps</h5>

            <ul class="row steps_style box_cat_upload">
                <li [ngClass]="[active_product ? 'box-item_active' : '', showUploadDocuments ? 'boxOutline' : 'box-item']"
                    class="col-lg-2 col-md-2 col-sm-3 col-4  clickable"
                    (click)="showUploadDocuments ? goToCatExecutionScreen('uploadDocs') : null">
                    1.
                    Upload documents</li>
                <li [ngClass]="[active_eStamp ? 'box-item_active' : '', showEstampDetails ? 'boxOutline' : 'box-item',
                uploadDocumentsData == undefined ? 'noclick' : '']" class="col-lg-2 col-md-2 col-sm-3 col-4  clickable"
                    (click)="showEstampDetails ? goToCatExecutionScreen('estamp') : null">2.
                    E-stamp details</li>
                <li [ngClass]="[active_eSign ? 'box-item_active' : '', showEsignDetails ? 'boxOutline' : 'box-item',
                uploadDocumentsData == undefined || estampData == undefined ? 'noclick' : '']"
                    class="col-lg-2 col-md-2 col-sm-3 col-4  clickable"
                    (click)="showEsignDetails ? goToCatExecutionScreen('esign') : null">3.
                    E-sign
                    details<span *ngIf="!showEsignForm">(skipped)</span></li>

                <li [ngClass]="[active_confirm ? 'box-item_active' : '', showConfirmation ? 'boxOutline' : 'box-item',
                uploadDocumentsData == undefined || estampData == undefined || esignData.length == 0 ? 'noclick' : '']"
                    class="col-lg-2 col-md-2 col-sm-3 col-4  clickable"
                    (click)="showConfirmation ? goToCatExecutionScreen('confirmation') : null">4. Order confirmation
                </li>

            </ul>
        </div>
    </div>

    <!-- Created useable components  so that we can use in estamp , esign and cat-upload Services     -->

    <div *ngIf="showUploadDocuments">
        <app-cat-execution-upload-documents #uploadData [uploadDocumentsData]="uploadDocumentsData"
            (productDetailsChange)="onproductDetailsChange($event)"></app-cat-execution-upload-documents>
    </div>

    <!-- <div *ngIf="showEstampDetails">
        <app-e-stamp-details [estampData]="estampData"
            (estampChange)="onestampDataChange($event)"></app-e-stamp-details>
    </div> -->

    <div *ngIf="showEstampDetails">
        <app-estamp-details [estampData]="estampData" (estampChange)="onestampDataChange($event)"></app-estamp-details>
    </div>

    <div *ngIf="showEsignDetails">
        <app-e-sign-details [esignData]="esignData" [triggerPopulate]="esignTrigger" [showESignOptions]="true" (esignDataChange)="onesignDataChange($event)" (draftChange)="onDraftChanged($event)" [service]="service"></app-e-sign-details>
    </div>

    <div *ngIf="showConfirmation">
        <app-order-confirmation-details #orderDetails [orderConfirmationData]="orderConfirmationData"
            (orderConfirmationChange)="onOrderConfirmationChange($event)"></app-order-confirmation-details>
    </div>

</div>

<div class="toast_display_layer">
    <p-toast></p-toast>
</div>


<p-confirmDialog [style]="{width: '50vw'}" (onAccept)="onApproveMethod()"></p-confirmDialog>


<ng-template #reviewOrder let-modal>
    <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModel()"
            aria-label="Close"></button>
    </div>
    <div class="modal-content">
        <div class="modal-body">
            <app-review-order-details [reviewOrderData]="reviewOrderData"
                (reviewOrderDataChange)="reviewOrderDataChange($event)"></app-review-order-details>
        </div>
    </div>
</ng-template>


<ng-template #paymentScreen let-modal>

    <div class="modal-header">
      <strong *ngIf="paymentDetails.paymentMethod==='razorpay' || paymentDetails.paymentMethod==='HDFC_GATEWAY'">Payment Details</strong>
      <strong *ngIf="paymentDetails.paymentMethod==='wallet'">Payment Details (Wallet)</strong>
      <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModel()" aria-label="Close"></button>
    </div>
    <div class="modal-content">
      <div class="modal-body">
      <app-payment-order [paymentOrderData]="paymentOrderData"
      (paymentOrderDataChange)="paymentOrderDataChange($event)"></app-payment-order>
      </div>
    </div>
  </ng-template>